var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlockLove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.25 6.80723C7.25 4.15227 9.37665 2 12 2C14.6234 2 16.75 4.15227 16.75 6.80723V7.83132H18C19.1046 7.83132 20 8.73754 20 9.85542V19.9759C20 21.0938 19.1046 22 18 22H6C4.89543 22 4 21.0938 4 19.9759V9.85542C4 8.73754 4.89543 7.83132 6 7.83132H7.25V6.80723ZM12 3.51807C10.2051 3.51807 8.75 4.99068 8.75 6.80723V7.83132H15.25V6.80723C15.25 4.99068 13.7949 3.51807 12 3.51807ZM8 14.3659C8 15.8337 9.60777 17.386 10.7847 18.3257C11.3175 18.7511 11.5839 18.9639 12 18.9639C12.4161 18.9639 12.6825 18.7511 13.2153 18.3257C14.3922 17.386 16 15.8337 16 14.3659C16 11.9139 13.7999 10.9985 12 12.8926C10.2001 10.9985 8 11.9139 8 14.3659Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlockLove);
export default __webpack_public_path__ + "static/media/padlock-love.7b216fad2186a9dcb7c38e13de46dbfa.svg";
export { ForwardRef as ReactComponent };